import { useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function MetalPergolasCTA() {
  const sectionRef = useRef<HTMLElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("opacity-100", "translate-y-0");
          entry.target.classList.remove("opacity-0", "translate-y-8");
        }
      });
    }, {
      threshold: 0.15
    });
    if (textRef.current) observer.observe(textRef.current);
    if (imageRef.current) observer.observe(imageRef.current);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="bg-background text-foreground relative overflow-hidden">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=DM+Sans:wght@300;400;500&display=swap');`}</style>

      <div className="relative w-full min-h-[90vh] flex flex-col lg:flex-row items-stretch">

        <div ref={imageRef} className="opacity-0 translate-y-8 transition-all duration-1000 ease-out relative w-full lg:w-[65%] min-h-[55vw] lg:min-h-[90vh] overflow-hidden">
          <img className="w-full h-auto absolute inset-0 w-full h-full object-cover object-center" alt="Modern garden retreat with pergola" src="https://nicklandscapes.co.uk/wp-content/uploads/2026/09/20250514_104821-scaled.jpg" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background/60 hidden lg:block" />
          <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent lg:hidden" />

          <div className="absolute top-8 left-8 border border-white/30 text-white px-4 py-1.5" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.65rem",
          letterSpacing: "0.2em"
        }}>
            ENJOY LIFE OUTDOORS
          </div>
        </div>

        <div ref={textRef} className="opacity-0 translate-y-8 transition-all duration-1000 delay-200 ease-out relative z-10 flex items-center lg:w-[35%] lg:-ml-24">
          <div className="bg-background/95 backdrop-blur-sm lg:shadow-2xl w-full mx-4 lg:mx-0 my-8 lg:my-16 p-10 lg:p-14 flex flex-col justify-center min-h-[340px]">

            

            <div className="mb-1" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "0.7rem",
            letterSpacing: "0.12em",
            color: "hsl(var(--muted-foreground))",
            fontWeight: 300
          }}>
              —
            </div>

            <p className="text-muted-foreground text-sm mb-2" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 300
          }}>
              We are here to help
            </p>

            <h2 className="mb-6 text-foreground leading-[1.1]" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "clamp(2.6rem, 4vw, 3.8rem)",
            fontWeight: 300,
            letterSpacing: "-0.01em"
          }}>
              Let’s Get Your Project Moving!
            </h2>

            <div className="w-12 h-px bg-foreground/20 mb-6" />

            <p className="text-muted-foreground mb-10 leading-relaxed" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "0.95rem",
            fontWeight: 300,
            lineHeight: "1.75"
          }}>If you’re in Dulwich or anywhere across South London, now’s the time to get it sorted. Speak with our team, walk us through your ideas, and we’ll give you straightforward advice with a clear plan to match. Get in touch with us for a free consultation!&nbsp;<div><br /></div></p>

            

          </div>
        </div>

      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-border/50" />
    </section>;
}